import { api } from './client'
import type { AuditLogEntry, Paged, Role, TenantUser } from './types'

export const usersApi = {
  list(): Promise<TenantUser[]> {
    return api.get<TenantUser[]>('/users')
  },

  invite(email: string, role: Role, name?: string): Promise<TenantUser> {
    return api.post<TenantUser>('/users', { email, role, name })
  },

  remove(id: string): Promise<void> {
    return api.delete<void>(`/users/${id}`)
  },
}

export const auditLogsApi = {
  list(page = 1, pageSize = 50): Promise<Paged<AuditLogEntry>> {
    return api.get<Paged<AuditLogEntry>>('/audit-logs', { query: { page, pageSize } })
  },
}
